export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
}

export function formatRank(index: number): string {
  return String(index + 1).padStart(2, '0');
}